import { render, staticRenderFns } from "./PlotPage.vue?vue&type=template&id=d048613c&scoped=true"
import script from "./PlotPage.vue?vue&type=script&lang=ts"
export * from "./PlotPage.vue?vue&type=script&lang=ts"
import style0 from "./PlotPage.vue?vue&type=style&index=0&id=d048613c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d048613c",
  null
  
)

export default component.exports